import React, { useState, useEffect } from 'react'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

//import '../styles.less'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
// import ObjectiveView from '../../../widgets/projectProposal/objectiveGoal/ObjectiveView'
import GoalWidget from '../../../widgets/projectProposal/objectiveGoal/GoalWidget'
import ObjctiveWidget from '../../../widgets/projectProposal/objectiveGoal/ObjctiveWidget'
import ResultWidget from '../../../widgets/projectProposal/objectiveGoal/ResultWidget'
import BtnEditAll from '../../../components/buttons/btnEditAll/BtnEditAll'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import { startLoading, doneLoading } from '../../../utils/loading'
import { getObjectiveGoal, getIndicators, getObjective, getOutcomeIndicator } from '../../../redux/actions/objectiveGoal'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import { getIsEditAll, setIsEditAll, handleOnChangeIsEdit } from '../../../utils/widget'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import pathname from '../../../constants/pathname'
import ActionPlanWidget from '../../../widgets/projectProposal/objectiveGoal/ActionPlanWidget'
import ConceptualWidget from '../../../widgets/projectProposal/objectiveGoal/ConceptualWidget'
import { Panel } from 'rsuite'
import Plan5YearWidget from '../../../widgets/projectProposal/objectiveGoal/Plan5YearWidget'

export default function OutcomeIndicator() {
  const [isEditWidget, setIsEditWidget] = useState({})
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  const [indicatorForm, setIndicatorForm] = useState()
  const [plan5YearForm, setPlan5YearForm] = useState()
  const [showEditAll, setShowEditAll] = useState()

  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  const buttonRoute = {
    pathNameBackward: `${pathname.proposal.budget}`,
    pathNameForward: `${pathname.proposal.backgroundAndImportant}`,
  }

  const handleGetSchema = async (proposalId) => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getOutcomeIndicator(proposalId)
      // const _schema = mockSchema
      // console.log('ObjectiveGoal', JSON.stringify(_schema))
      setSchema(_schema)
      setIndicatorForm(_schema?.forms?.indicator)
      setPlan5YearForm(_schema?.forms?.plan5Year)
      setIsEditWidget({
        indicator: _schema.forms?.indicator?.indicatorsResult?.value?.length > 0 ? false : true,
      })
      setShowEditAll(!_schema.forms?.indicator?.disabled)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  useEffect(() => {
    handleGetSchema(projectId)
  }, [])

  const handleGetIndicator = async () => {
    try {
      const _schema = await getIndicators(projectId)
      // console.log('handleGetIndicator', _schema)
      setIndicatorForm(_schema)
    } catch (e) {}
  }

  const handleOnSuccess = async (res) => {
    console.log('res', res)
    if (res) {
      try {
        const _schema = await getObjective(projectId)
        console.log('_schema', _schema)
        setSchema((state) => ({
          ...state,
          forms: {
            ...state.forms,
            objective: _schema,
          },
        }))
      } catch (e) {
        console.log('error', e)
      }
    }
  }

  if (error) {
    return (
      <SidebarProposal>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <>
      <SidebarProposal>
        <ContentHeader
          header={'ตรวจสอบตัวชี้วัดและความเชื่อมโยงของยุทธศาสตร์การทำงาน'}
          subHeader={schema.subHeader}
        />

        {showEditAll && (
          <BtnEditAll
            onClickEditAll={getIsEditAll(isEditWidget)}
            routing={buttonRoute}
            setOnClickEditAll={(_isEdit) => setIsEditAll(_isEdit, isEditWidget, setIsEditWidget)}
            editWidget={isEditWidget}
            forms={schema?.forms}
          />
        )}

        {/* ผลลัพธ์และตัวชี้วัด */}
        {indicatorForm && (
          <>
            <ResultWidget
              showCommandButton={true}
              schema={indicatorForm}
              isEdit={isEditWidget.indicator || true}
              onChangeIsEdit={(_isEdit) =>
                handleOnChangeIsEdit('indicator', _isEdit, setIsEditWidget)
              }
              //onSuccess={(res) => handleOnSuccess(res)}
              isCoordinator={true}
            />
            <br />
          </>
        )}

         {/* แผน 5 ปี */}
         {plan5YearForm && (
          <>
            <Plan5YearWidget
              showCommandButton={!plan5YearForm.disabled}
              schema={plan5YearForm}
            />
            <br />
          </>
        )}
        
      </SidebarProposal>
    </>
  )
}
